import logo from './logo.png'

export const theme = {
    color: {
      primary: "#EF8400",
      primaryHover: "#767A7E",
    },
    logoImage: logo,
    backend: "https://bayer-basketball.epaper-publishing-one.de/",
    directory: "/kiosk",
    header: {
      customer: "",
      title: "BAYERN-BASKET digital",
      lineHeader: true,
    },
    info: [
      {
        text: 'Impressum',
        link: 'https://basketballverband-bayern.de/impressum/'
      },
      {
        text: 'Datenschutz',
        link: 'https://basketballverband-bayern.de/twelve-layout-copy/datenschutz/'
      }
  ]
  };